// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IntegrationCallStateOverviewListResultModel from '../../model/integration-call-state-overview-list-result-model';
import IntegrationCallStateOverviewListResultDTO from '../dto/integration-call-state-overview-list-result-dto';
import dtoSchema from '../schemas/integration-call-state-overview-list-result-schema';
import IntegrationCallStateOverviewModel from '../../model/integration-call-state-overview-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class IntegrationCallStateOverviewListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IntegrationCallStateOverviewListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => IntegrationCallStateOverviewModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: IntegrationCallStateOverviewModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<IntegrationCallStateOverviewListResultDTO>): IntegrationCallStateOverviewListResultModel;
  static toModel(dto: DeepPartial<IntegrationCallStateOverviewListResultDTO> | undefined | null): IntegrationCallStateOverviewListResultModel | undefined;
  static toModel(dto: DeepPartial<IntegrationCallStateOverviewListResultDTO> | undefined | null): IntegrationCallStateOverviewListResultModel | undefined {
    return dto ? new IntegrationCallStateOverviewListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IntegrationCallStateOverviewListResultModel> | IntegrationCallStateOverviewListResultModel): IntegrationCallStateOverviewListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as IntegrationCallStateOverviewListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for IntegrationCallStateOverviewListResultModel, can not map to IntegrationCallStateOverviewListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
